import auth from './Auth'
import area from './Area'
import address from './Address'
import categories from './Categories'
import registration from './Registration'
import markTypes from './MarkType'
import markRules from './MarkRules'
import cart from './Cart'
import cookieLaw from './CookieLaw'
import {reducer as form} from 'redux-form'

export {
    auth,
    area,
    address,
    categories,
    registration,
    markTypes,
    markRules,
    cart,
    cookieLaw,
    form
}


// WEBPACK FOOTER //
// ./src/redux/modules/index.js